import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import { getApiUrl } from '../config/api';

// API Configuration
const API_BASE_URL = getApiUrl();

// Create axios instance
const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // Increased timeout to 30 seconds
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Log API configuration for debugging
console.log('🔧 API Configuration:', {
  baseURL: API_BASE_URL,
  hostname: window.location.hostname,
  isProduction: window.location.hostname !== 'localhost' && 
                window.location.hostname !== '127.0.0.1' &&
                !window.location.hostname.includes('localhost')
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear token and redirect to login
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// API Response types
export interface ApiResponse<T = any> {
  data: T;
  message?: string;
  status: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

// API Error types
export interface ApiError {
  message: string;
  errors?: Record<string, string[]>;
  status: number;
}

// Export the configured axios instance
export default api;